



































































































































































































































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BaseTab from './baseTab'
import dayjs from 'dayjs'
import { ExStore } from 'vuex'
import { PrivatePatient } from '@/types/user'
import { EventEmitter } from 'events'

const enum EventTypes {
  CONFIRM_DONE
}

const enum ModalReactTypes {
  OK,
  CANCEL
}

@Component({
  filters: {
    prefecture(value: string) {
      return [
        { value: '01', text: '北海道' },
        { value: '02', text: '青森県' },
        { value: '03', text: '岩手県' },
        { value: '04', text: '宮城県' },
        { value: '05', text: '秋田県' },
        { value: '06', text: '山形県' },
        { value: '07', text: '福島県' },
        { value: '08', text: '茨城県' },
        { value: '09', text: '栃木県' },
        { value: '10', text: '群馬県' },
        { value: '11', text: '埼玉県' },
        { value: '12', text: '千葉県' },
        { value: '13', text: '東京都' },
        { value: '14', text: '神奈川県' },
        { value: '15', text: '新潟県' },
        { value: '16', text: '富山県' },
        { value: '17', text: '石川県' },
        { value: '18', text: '福井県' },
        { value: '19', text: '山梨県' },
        { value: '20', text: '長野県' },
        { value: '21', text: '岐阜県' },
        { value: '22', text: '静岡県' },
        { value: '23', text: '愛知県' },
        { value: '24', text: '三重県' },
        { value: '25', text: '滋賀県' },
        { value: '26', text: '京都府' },
        { value: '27', text: '大阪府' },
        { value: '28', text: '兵庫県' },
        { value: '29', text: '奈良県' },
        { value: '30', text: '和歌山県' },
        { value: '31', text: '鳥取県' },
        { value: '32', text: '島根県' },
        { value: '33', text: '岡山県' },
        { value: '34', text: '広島県' },
        { value: '35', text: '山口県' },
        { value: '36', text: '徳島県' },
        { value: '37', text: '香川県' },
        { value: '38', text: '愛媛県' },
        { value: '39', text: '高知県' },
        { value: '40', text: '福岡県' },
        { value: '41', text: '佐賀県' },
        { value: '42', text: '長崎県' },
        { value: '43', text: '熊本県' },
        { value: '44', text: '大分県' },
        { value: '45', text: '宮崎県' },
        { value: '46', text: '鹿児島県' },
        { value: '47', text: '沖縄県' }
      ].find(v => v.value == value)?.text
    }
  },
  components: {
    AlertModal: () => import('@/components/common/modals/AlertModal.vue')
  }
})
export default class BasicInfo extends mixins(BaseTab) {
  $store!: ExStore
  workersInstitutionCode = ''
  workersInstitutionName = ''
  events = new EventEmitter()
  showAlertModal = false
  archivePending = false
  isLocalIdEditing = false
  draftLocalId = ''

  async handleClickArchive() {
    if (this.archivePending) {
      return
    }

    try {
      this.archivePending = true
      this.showAlertModal = true

      const result = await new Promise(resolve =>
        this.events.once(EventTypes.CONFIRM_DONE, resolve)
      )

      this.showAlertModal = false

      if (result === ModalReactTypes.CANCEL) {
        return
      }

      await this.$store.dispatch('patient/patchCurrentPatient', {
        patientId: this.patient.id,
        params: { isEnabled: false }
      })
    } catch (error) {
      console.error(error)
    } finally {
      this.archivePending = false
    }
  }

  async handleUpdatePatientLocalId() {
    const patientLocalId = this.draftLocalId
    const institutions = this.patient.institutions.map(i => {
      if (i.institution !== this.workersInstitutionCode) return i
      return Object.assign(i, { patientLocalId })
    })
    if (
      !institutions
        .map(i => i.institution)
        .includes(this.workersInstitutionCode)
    ) {
      institutions.push({
        patient: String(this.patient.id),
        institution: this.workersInstitutionCode,
        institutionName: this.workersInstitutionName,
        patientLocalId
      })
    }

    await this.$store.dispatch('patient/patchCurrentPatient', {
      patientId: this.patient.id,
      params: { institutions }
    })

    this.isLocalIdEditing = false
    this.$store.dispatch('patient/updateCurrentPatient', {
      patientId: this.patient.id
    })
  }

  handleConfirmOk() {
    this.events.emit(EventTypes.CONFIRM_DONE, ModalReactTypes.OK)
  }

  handleConfirmCancel() {
    this.events.emit(EventTypes.CONFIRM_DONE, ModalReactTypes.CANCEL)
  }

  async created() {
    const worker = await this.$api.user.worker({ workerId: this.userInfo.id })
    this.workersInstitutionCode = worker.institution
    this.workersInstitutionName = worker.institutionName
    this.draftLocalId = this.patientLocalId
  }

  get patientLocalId() {
    const mainInstitution = this.patient?.institutions.find(
      i => i.institution === this.workersInstitutionCode
    )
    return mainInstitution ? mainInstitution.patientLocalId : ''
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get patient() {
    return this.$store.getters['patient/currentPatient'] as PrivatePatient
  }

  get patientName() {
    if (!this.patient) return ''
    return `${this.patient.lastName}${this.patient.firstName}`
  }

  get birthdayString() {
    if (!this.patient) return ''
    const date = dayjs(this.patient.birthDate)
    return date.format('YYYY年M月D日')
  }

  get hasInstitution() {
    return (
      this.patient.institution1Name ||
      this.patient.institution1PatientId ||
      this.patient.institution2Name ||
      this.patient.institution2PatientId ||
      this.patient.institution3Name ||
      this.patient.institution3PatientId
    )
  }

  get hasCareService() {
    return (
      this.patient.careservice1Name ||
      this.patient.careservice1ContractId ||
      this.patient.careservice2Name ||
      this.patient.careservice2ContractId ||
      this.patient.careservice3Name ||
      this.patient.careservice3ContractId
    )
  }
}
